// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'inbox-data-solid';

export const Component = () => (
  <path d='M23.467 13.734h-7.47v.526a3.658 3.658 0 0 1-1.102 2.635 3.656 3.656 0 0 1-2.635 1.101 3.658 3.658 0 0 1-2.634-1.101 3.656 3.656 0 0 1-1.102-2.635v-.526h-7.47L4.788 3.102H19.73l3.736 10.632Zm1.054 0L20.26 2H4.262L0 13.734v9.626h24.521v-9.626ZM4.262 10.525v2.155h1.054v-1.053h13.89v1.053h1.053v-2.155H4.263Zm2.156-1.053V8.418h11.686v1.054h1.101V7.365H5.316v2.107h1.102Zm1.053-3.21V5.21h9.579v1.054h1.054V4.155H6.418v2.107h1.054Z' />
);

export const viewBox = '0 0 25 25';
